document.addEventListener('DOMContentLoaded', function() {
	document.querySelector('select[name="options[Item]"]').addEventListener('change', function(e) {
		e.preventDefault(); 
	});
});

/*offer form*/ 
function openFormFun(){
	let overlay = document.getElementById('overlay');
	let slideForm = document.getElementById('slideForm');
	slideForm.classList.add('active');
	overlay.classList.add('active');
	document.body.style.overflow = 'hidden';
}

function closeFormFun(){
	let overlay = document.getElementById('overlay');
	let slideForm = document.getElementById('slideForm');
	slideForm.classList.remove('active');
	overlay.classList.remove('active');
	document.body.style.overflow = ''; 
}


/*tabs toggle*/
function toggleAccordion(header) {
	const contents = document.querySelectorAll('.tabs_content');
	const headers = document.querySelectorAll('.tabs_head');
	
	const content = header.nextElementSibling;
	const isActive = content.classList.contains('active');
	
	contents.forEach(item => {
		item.classList.remove('active');
	});
	
	headers.forEach(item => {
		item.classList.remove('active');
	});
	
	if (!isActive) {
		content.classList.add('active');
		header.classList.add('active');
	}
}

// tabs description mobile
if(window.screen.width < 1024){
	$("tabs-component .product-tabNav-mobile").click(function(){
		let isOpen = $(this).attr("data-open")
		let groupIndex = $(this).attr("data-group-index")
		if(isOpen == "false"){
			$(".tabs-component-content").hide()
			$(`.tabs-component-content[data-group-index="${groupIndex}"]`).fadeIn(300)
			$(this).attr("data-open",true).siblings(".product-tabNav-mobile").attr("data-open",false)
		}else{
			$(`.tabs-component-content[data-group-index="${groupIndex}"]`).hide()
			$(this).attr("data-open",false)
		}
	})
}